import { render, staticRenderFns } from "./GlobalFooter.vue?vue&type=template&id=2b74011e&scoped=true&"
import script from "./GlobalFooter.vue?vue&type=script&lang=ts&"
export * from "./GlobalFooter.vue?vue&type=script&lang=ts&"
import style0 from "./GlobalFooter.vue?vue&type=style&index=0&id=2b74011e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b74011e",
  null
  
)

export default component.exports